import React, {useState} from 'react';
import './Tabs.scss';


const Tabs = (props) => {

    const [activeTabIndex, setActiveTabIndex] = useState(0);

    const panelClass = (i) => {
        let commonClass = 'panels__elem';
        if(i === activeTabIndex) {
            commonClass += ' active';
        }
        return commonClass;
    }

    const tabClass = (i) => {
        let commonClass = 'tab-list__elem';
        if(i === activeTabIndex) {
            commonClass += ' tab-list__elem_active';
        }
        return commonClass;
    }

    const tabHandleClick = (i) => {
      return (e) => setActiveTabIndex(i);
    };
    const tabList = React.Children.map(props.children, (child, index) => {
        return <li key={index} onClick={tabHandleClick(index)} className={tabClass(index)}>{child.props.title}</li>
    });

    const tabPanels = React.Children.map(props.children, (child, index) => {
        return (<li key={index} className={panelClass(index)}>{child}</li>);
    });
    return (
        <div className="tabs">
            <ul className="tab-list">
                {tabList}
            </ul>
            <ul className="tab-panels">
                {tabPanels}
            </ul>
        </div>
    )
};

export default Tabs;